import { FC } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { MDSLoadingIconProps, MDSLoadingIconSize } from "./loading-icon.types";
import { StyledLoadingIconContainer } from "./loading-icon.styles";
import loadingIconAnimation from "@/assets/images/loading-icon-tomato.lottie?url";

export const MDSLoadingIcon: FC<MDSLoadingIconProps> = ({
  size = MDSLoadingIconSize.Medium,
  className,
  loop = true,
  speed = 1.0,
}) => {
  return (
    <StyledLoadingIconContainer size={size} className={className}>
      <DotLottieReact
        src={loadingIconAnimation}
        loop={loop}
        autoplay
        speed={speed}
        style={{ width: "100%", height: "100%" }}
      />
    </StyledLoadingIconContainer>
  );
};
